import axios from '@/libs/api.request'
// 获取活动列表
export const getRotorList = (params) => {
    return axios.request({
        url: 'rotor',
        method: 'get',
        params: params
    })
}

// 获取活动详情
export const getRotorDetails = (params) => {
    return axios.request({
        url: `rotor/${params.id}`,
        method: 'get'
    })
}